import { useEffect, useState } from "react";
import ReportDom from "../../../components/common/ReportDom";
import SalesVoucherBody from "./SalesVoucherBody";

export default function PrintSalesVoucher({id : sale_id}) {  
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // preload any required lookup data here
    setReady(true);
  }, []);

  if (!ready) return null;

  return (
    <div style={{ background: "#fff", padding: 0 }}>
      <ReportDom
        renderTable={() => (
          <SalesVoucherBody
            sale_id={sale_id}
            printMode
            showStamp
            showSignature
          />
        )}
      />
    </div>
  );
}
